export default __webpack_public_path__ + "static/media/play.f1048d27.svg";